<template>
  <MaterialCard
    color="green"
    full-width
  >
    <v-tabs>
      <v-tab ripple>
        情報
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="audit.id"
                    label="id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="category.name"
                    class="purple-input"
                    label="カテゴリ"
                    readonly
                  />
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    v-model="user.name"
                    label="ユーザー"
                    class="purple-input"
                    readonly
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-textarea
                    v-model="audit.detail"
                    label="説明"
                    class="purple-input"
                    readonly
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </MaterialCard>
</template>
<script>
export default {
  // eslint-disable-next-line
  props: {
    audit: {
      type: Object,
      default: () => null
    },
    categories: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  computed: {
    category () {
      return this.categories.find(c => c.id === this.audit.categoryId)
    },
    user () {
      return this.users.find(u => u.id === this.audit.userId)
    }
  }
}
</script>
